import { Droplets, Fuel, Ruler, Scale, type LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

export type MonitoreoSeccion = 'surtidor' | 'tanques' | 'conciliacion' | 'medicion';

interface Enlace {
  seccion: MonitoreoSeccion;
  to: string;
  label: string;
  icon: LucideIcon;
}

const ENLACES: readonly Enlace[] = [
  { seccion: 'surtidor', to: '/monitoreo/surtidor', label: 'Surtidor en vivo', icon: Fuel },
  { seccion: 'tanques', to: '/monitoreo/tanques', label: 'Tanques en vivo', icon: Droplets },
  { seccion: 'conciliacion', to: '/monitoreo/conciliacion', label: 'Conciliación', icon: Scale },
  {
    seccion: 'medicion',
    to: '/monitoreo/medicion-tanques',
    label: 'Medición de Tanques Controlador',
    icon: Ruler,
  },
];

const BASE =
  'inline-flex items-center gap-2 rounded-control px-3 py-2 text-xs font-semibold transition-colors';
const INACTIVO = 'border border-ink-200 bg-white text-ink-700 hover:border-brand-300 hover:text-brand-700';
const ACTIVO = 'bg-ink-900 text-white';

/** Submenú de las pantallas en vivo del controlador. */
export function MonitoreoNav({ active, className }: { active: MonitoreoSeccion; className?: string }) {
  return (
    <nav className={cn('flex flex-wrap items-center gap-2', className)} aria-label="Monitoreo en vivo">
      {ENLACES.map((enlace) => (
        <Link
          key={enlace.seccion}
          to={enlace.to}
          aria-current={enlace.seccion === active ? 'page' : undefined}
          className={cn(BASE, enlace.seccion === active ? ACTIVO : INACTIVO)}
        >
          <enlace.icon className="size-3.5" aria-hidden="true" />
          {enlace.label}
        </Link>
      ))}
    </nav>
  );
}
